import React from 'react';

import { Link } from 'react-router-dom';

interface FooterLinkProps {
    title: string;
    links: Array<{ href?: string; link?: string; name: string }>;
    last?: boolean;
}

export const FooterLink: React.FC<FooterLinkProps> = React.memo(
    ({ title, links, last }) => (
        <ul className={`footer__container__links__list none ${last && 'last'}`}>
            <li className='footer__container__links__list__item'>
                <h4 className='footer__container__links__list__item__title'>
                    {title}
                </h4>
            </li>
            {links.map((link: any) => (
                <div key={link.name}>
                    <li className='footer__container__links__list__item'>
                        {link.href ? (
                            <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href={link.href}
                                className='footer__container__links__list__item__link'
                            >
                                {link.name}
                            </a>
                        ) : (
                            <Link
                                to={link.link}
                                className='footer__container__links__list__item__link'
                            >
                                {link.name}
                            </Link>
                        )}
                    </li>
                </div>
            ))}
        </ul>
    )
);
